import React from "react";

const benefits = [
  "Ask about the 2026–⁠27 Union Budget alongside earlier years",
  "Compare allocations across ministries and financial years",
  "Follow every answer back to the official source document",
];

function AuthLayout({ title, subtitle, children }) {
  return (
    <main className="auth-shell">
      <div className="container auth-shell-grid">
        <aside className="auth-aside">
          <div className="eyebrow cta-eyebrow">Aivio · India Budget demo</div>
          <h2>See role-based access <span>in action.</span></h2>
          <p>Budget data for 2020–⁠21 to 2022–⁠23 is open to everyone. A free account unlocks 2023–⁠24 to 2026–⁠27, so you can see how Aivio controls what each user can access.</p>
          <ul>{benefits.map((item) => <li key={item}><span aria-hidden="true">✓</span>{item}</li>)}</ul>
          <div className="auth-aside-mark" aria-hidden="true">✦</div>
        </aside>
        <section className="auth-card">
          <h1>{title}</h1>
          {subtitle && <p className="auth-subtitle">{subtitle}</p>}
          {children}
        </section>
      </div>
    </main>
  );
}

export default AuthLayout;
